<template>
	<div class="scrolly-intro-1" v-if="sections.length">
		<div class="scrolly-intro-1-further-cont" v-if="!isMobile">
			<div class="scrolly-intro-image" v-html="buildingImage"></div>
			<div class="scrolly-go-back stack-horizontal pointer" data-align="center" @click="goBack">
				<base-icon name="back_arrow"/>
				<p class="font-regular capitalize-first">{{$t('scrolly_back_home')}}</p>
			</div>
			<div class="scrolly-title-cont stack-vertical">
				<h1 v-for="(line, i) in scrollyNameArray" :class="'scrolly-title '+(i == 0 ? 'capitalize-first ' : '')+(i%2==0 ? 'left' : 'right')">{{line}}</h1>
			</div>
			<div class="stack-vertical scrolly-instructions" data-align="center">
				<p class="capitalize-first">{{$t('scrolly_istruzioni_scroll')}}</p>
				<div class="scrolly-loader-container">
					<div class="scrolly-loader"></div>
					<base-icon name="down_arrow" />
				</div>
			</div>
			<div class="scrolly-intro-curtain"></div>
			<div class="scrolly-intro-contents-cont grid-horizontal" v-if="!isMobile">
				<div class="stack-vertical scrolly-intro-contents">
					<h3 v-if="scrolly.description" class="font-regular capitalize-first">{{scrolly.description[$i18n.locale]}}</h3>
					<div v-if="$i18n.locale == 'en' && scrolly.nameCode == 'come-suona-italiano-popolare'">Warning: for the sake of clarity, the texts in “incorrect” Italian have been translated into generally standard English, except for some slight nuances of… broken English!</div>
					<div class="scrolly-intro-button stack-horizontal pointer" @click="showPlayer">
						<base-icon name="video-gallery-3" />
						<h3 class="font-regular capitalize-first">{{$t('scrolly_istruzioni_audio')}}</h3>
					</div>
				</div>
			</div>
			<img decoding="async" :class="`scrolly-intro-1-image scrolly-intro-1-image-${i+1}`" v-for="(image, i) in scrolly.introImages" :src="imageIntroMobileFromIndex(i)" />
		</div>
		<div class="scrolly-intro-1-further-cont" v-if="isMobile">
			<div class="scrolly-intro-image" v-html="buildingImage"></div>
			<h2 class="scrolly-mobile-title-cont capitalize-first">{{scrolly.name[$i18n.locale]}}</h2>
			<div class="stack-vertical scrolly-instructions" data-align="center">
				<p class="capitalize-first">{{$t('scrolly_istruzioni_scroll')}}</p>
				<div class="scrolly-loader-container">
					<div class="scrolly-loader"></div>
					<base-icon name="down_arrow" />
				</div>
			</div>
		</div>
		<div class="scrolly-intro-contents-cont grid-horizontal" v-if="isMobile">
			<div class="stack-vertical scrolly-intro-contents">
				<h3 v-if="scrolly.description" class="font-regular capitalize-first">{{scrolly.description[$i18n.locale]}}</h3>
				<div v-if="$i18n.locale == 'en' && scrolly.nameCode == 'come-suona-italiano-popolare'">Warning: for the sake of clarity, the texts in “incorrect” Italian have been translated into generally standard English, except for some slight nuances of… broken English!</div>
				<div v-if="$i18n.locale == 'it'" class="scrolly-intro-button stack-horizontal pointer" @click="showPlayer">
					{{$i18n.locale}}
					<base-icon name="video-gallery-3" />
					<div class="font-regular capitalize-first">{{$t('scrolly_istruzioni_audio')}}</div>
				</div>
				<img v-if="imageIntroMobile" :src="imageIntroMobileFromIndex(imageIntroMobile.index)" class="intro-image-mobile" :style="imageIntroMobile.customStyle">
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	
import { mapGetters } from 'vuex';
import utils from '@js/utils.js';

export default {
	name: 'InterfaceScrollyIntroSection',
	props: {
		sections: {
			type: Array,
			default: []
		},
		scrolly: {
			type: Object,
			default: null
		},
		imageIntroMobile: {
			type: Object
		}
	},
	data() {
		return {

		}
	},
	computed: {
		...mapGetters(['isMobile']),
		buildingImage() {
			return require('@assets/images/Edificio-2.svg');
		},
		scrollyNameArray() {
			if (this.scrolly?.nameArray) return this.scrolly.nameArray[this.$i18n.locale];
			if (this.scrolly && this.$i18n) {
				return this.splitSentence(this.scrolly.name[this.$i18n.locale]);	
			}
			return [];
		},
	},
	methods: {
		showPlayer() {
			this.$emit('show-player')
		},
		goBack() {
			this.$emit('go-back')
		},
		splitSentence(sentence) {
		  const words = sentence.split(' '); // Split sentence into words
		  
		  // Loop through words and combine short words with next word
		  for (let i = 0; i < words.length - 1; i++) {
		    if (words[i].length < 3) {
		      words[i] = words[i] + ' ' + words[i + 1];
		      words.splice(i + 1, 1); // Remove the next word since it's been combined
		      i--; // Decrement i to re-evaluate the current word
		    }
		  }
		  
		  return words;
		},
		imageIntroMobileFromIndex(index) {
			return this.scrolly.introImages[index];
		},
	},
}

</script>

<style lang="scss">
	@import '@css/variables.scss';

	.scrolly-title {
		font-size: 7rem;
		height: 7rem;
		// transition-property: color, margin;
		// transition-duration: 0.5s;
	}

	.scrolly-title.left {
		transform: translateX(-3.5rem);
		// margin: 0 0 0 -7rem;
	}

	.scrolly-title.right {
		transform: translateX(3.5rem);
		// margin: 0 -7rem 0 0;
	}

	.scrolly-intro-1 {
		position: fixed;
		left: var(--menu-size);
		top: 0;
		width: calc(100vw - var(--menu-size));
		height: 100vh;
		background-color: var(--color-brand-blue);
		overflow: hidden;
		z-index: 2;
	}

	.scrolly-intro-1-further-cont {
		position: relative;
		min-width: 100%;
		min-height: 100vh;
		background: linear-gradient(72.04deg, #F9CAD0 49.3%, #FFFFFF 130.69%);
	}

	.scrolly-go-back {
		position: absolute;
		left: 3rem;
		top: calc(var(--total-bar-height) + 2.5rem);
		gap: 0.75rem;
		font-family: 'arzachel';
	}

	.scrolly-intro-1-image {
		position: absolute;
		left: 0;
		top: 0;
	}

	.scrolly-intro-1-image-1 {
		height: 65vh;
		transform: translate(calc(100vw + 100%), calc(100vh + 100%));
	}

	.scrolly-intro-1-image-2 {
		height: 65vh;
		transform: translate(-100%, calc(100vh + 100%)) rotate(-20deg);
	}

	.scrolly-intro-1-image-3 {
		height: 35vh;
		transform: translate(calc(50vw - 30%), -150%) rotate(15deg);
	}

	.scrolly-intro-video {
		position: absolute;
		top: 0;
		height: 100%;
		width: 100%;
		object-fit: cover;
		filter: grayscale(1);
	}

	.scrolly-intro-curtain {
		position: absolute;
		bottom: 0;
		width: 100%;
		height: 0;
		background-color: var(--color-brand-blue);
		z-index: -1;
	}

	.scrolly-intro-curtain.active {
		height: 100%;
	}

	.scrolly-title-cont {
		width: fit-content;
		position: absolute;
		right: 7rem;
		transform: translate(-12vw, -50%);
		top: 50%;
		color: var(--color-black-text);
	}

	.scrolly-intro-image {
		position: absolute;
		left: 0;
		bottom: 0;
		transform-origin: bottom right;
		transform: translate(-5rem, 22%);
		width: 60vw;
	}

	.scrolly-instructions {
		position: absolute;
		bottom: 3rem;
		left: calc(50vw - var(--menu-size));
		transform: translate(-50%, 0);
	}

	.scrolly-instructions .svg-icon {
		--svg-icon-color: var(--color-brand-blue);
		width: var(--s3);
		transform: translate(0, 0.5rem);
	}

	.scrolly-instructions p {
		text-align: center;
	}

	.scrolly-instructions.active .svg-icon {
		--svg-icon-color: var(--color-white);
	}

	.grid-horizontal.scrolly-intro-contents-cont {
		grid-template-columns: 1fr;
		// grid-template-columns: 1.5fr 1fr;
		gap: 11.6rem;
		position: absolute;
		left: 0;
		top: 0;
		transform: translate(calc(50vw - var(--menu-size) - 50%), calc(100vh + 100%));
		max-width: 50vw;
		height: fit-content;
		color: var(--color-black);
		z-index: 2;
		display: inline-block;
	}

	.scrolly-intro-contents {
		align-items: center;
		text-align: center;
		gap: var(--s4);
	}

	.scrolly-intro-button {
		background: rgba(255, 255, 255, 0.3);
		backdrop-filter: blur(7px);
		height: 4.5rem;
		width: fit-content;
		gap: var(--s3);
		align-items: center;
		padding: 0 var(--s3);
		border: solid 2px var(--color-black);
	}

	@media(max-width: $breakpoint-mlll) {
		.scrolly-title {
			font-size: 5rem;
			height: 5rem;
		}

		.scrolly-title-cont {
			transform: translate(-10vw, -50%);
		}
	}

	@media(max-width: $breakpoint-mll) {
		.scrolly-title-cont {
			transform: translate(0, -50%)
		}
	}


	@media (max-width: $breakpoint-sm) {
		.intro-image-mobile {
			position: absolute;
			bottom: 0;
			right: 0;
			z-index: -1;
		}

		.scrolly-intro-1 {
			position: relative;
			left: 0;
			top: 0;
			width: 100vw;
			height: unset;
			z-index: 0;
			background: linear-gradient(72.04deg, #F9CAD0 49.3%, #FFFFFF 130.69%);
		}
	
		.scrolly-intro-1-further-cont {
			height: var(--scrolly-h);
			min-height: unset;
			background: none;

			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			padding: 2rem 1rem;

			@media (min-height: 520px) {
				// /* fix for iphones with bottom bar... */
				padding-bottom: 8rem;
			}
		}

		.scrolly-intro-image {
			left: unset;
			bottom: 0;
			right: 100%;
			width: 80vw;
			transform: translate(40%, 40%);
			z-index: -1;
		}

		.grid-horizontal.scrolly-intro-contents-cont {
			z-index: 1;
			transform: none;
			min-width: unset;
			max-width: unset;
			position: static;
			padding: var(--s3) var(--s3) var(--s4);
			min-height: unset;
			display: flex;
			justify-content: space-around;
			flex-direction: column;
		}

		.scrolly-title {
			font-size: 2rem;
			height: 2rem;
			// transition-property: color, margin;
			// transition-duration: 0.5s;
		}

		.scrolly-instructions {
			// position: absolute;
			// bottom: 2rem;
			// left: 50%;

			position: relative;
			bottom: unset;
			left: unset;
			transform: none;
			z-index: 1;
		}

		.scrolly-intro-button {
			gap: 0.75rem;
			height: 3rem;
			padding: 0 0.5rem;
			width: 100%;
			font-family: 'laica';
			display: flex;
			justify-content: center;
		}

		.scrolly-mobile-title-cont {
			// position: absolute;
			// top: 5rem;
			// left: 15vw;
			// right: 15vw;
			color: var(--color-black-text);
			margin: auto;
			text-align: center;
			z-index: 1;
		}

		.scrolly-intro-1-image-2 {
			transform: translate(-35%, 145vh) rotate(-20deg);
			height: auto;
			width: 136vw;
			max-width: unset;
		}
	}

</style>
